/**
 * Labstep
 *
 * @module components/NotificationAlert/Form/ShowEdit/Message
 * @desc Message show edit for notification alert
 */

import { fieldNotificationAlertMessage } from 'labstep-web/components/NotificationAlert/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Pre } from 'labstep-web/core/Pre';
import type React from 'react';
import type { NotificationAlertFormShowEditMessageProps } from './types';

export const NotificationAlertFormShowEditMessage: React.FC<
  NotificationAlertFormShowEditMessageProps
> = ({ notificationAlert }) => (
  <ShowEditText
    entityName={notificationAlert.entityName}
    entity={notificationAlert}
    field={fieldNotificationAlertMessage}
  >
    <Pre>{notificationAlert.message}</Pre>
  </ShowEditText>
);
